<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card class="mb-5">
      <div class="vx-row">
        <div class="vx-col lg:w-1/4 w-full">
          <p>Day</p>
          <datepicker :format="format" v-model="search.date" class="w-full" name="day" @closed="getCourseClassByDay">
          </datepicker>
        </div>
        <div class="vx-col lg:w-1/4 w-full">
          <p>{{ $t('TrainingOrderNumber') }}</p>
          <v-select label="DisplayName" v-model="search.CourseClass" :options="courseClass"
            :reduce="CourseClass => CourseClass" @input="getModulesByCourseClass" />
        </div>

        <div class="vx-col lg:w-1/4 w-full">
          <p>{{ $t('Module') }}</p>
          <v-select label="Name" v-model="search.ModuleID" :options="modules" :reduce="module => module.ID" />
        </div>

        <vs-button class="mt-5" @click="loadTrainee" :disabled="!isFormValid">{{ $t('LoadTrainee') }}</vs-button>

      </div>
    </vx-card>
    <vx-card class="p-5" v-if="traineeParticipations.length > 0">

      <h2 style="color:red">{{ $t('ParticipationRange') }}</h2>
      <vs-table class="mr-5 ml-5" :max-items="10" :data="traineeParticipations">
        <template slot="thead">
          <vs-th sort-key="instructor">{{ $t('Trainee') }}</vs-th>
          <vs-th v-for="tr in traineeParticipations[0].TraineeParticipations"
            :key="tr.ID">{{ tr.ParticipationType.Name }}</vs-th>

        </template>
        <template>
          <tbody>

            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in traineeParticipations">
              <vs-th>
                {{ tr.FullName }}
              </vs-th>
              <vs-th v-for="tr in traineeParticipations[indextr].TraineeParticipations" :key="tr.ID">
                <vs-input type="number" v-model="tr.Grade" class="mt-5 w-full" name="name" />
              </vs-th>

            </vs-tr>
          </tbody>
        </template>
      </vs-table>

      <div class="flex flex-wrap items-end p-6" slot="footer">

        <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
        <vs-button type="border" color="danger" @click="initValues">{{ $t('Cancel') }}</vs-button>
        <vs-button type="border" class="ml-6" @click="PrintDailyFolloup">{{ $t('Print') }}</vs-button>
      </div>
    </vx-card>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
import moduleTraineeAttendance from "@/store/traineeAttendance/moduleTraineeAttendance.js";
import moduleTraineeParticipation from "@/store/traineeParticipation/moduleTraineeParticipation.js";
import vSelect from 'vue-select';
export default {
  components: {
    Datepicker,
    vSelect
  },
  data() {
    return {
      traineeParticipations: [],
      format: "dd-MM-yyyy",
      search: {},
      modules: [],
      currentRule: null,
    }
  },
  computed: {
    isFormValid() {
      return this.search.date && this.search.CourseClass;
    },
    courseClass() {
      return this.$store.state.courseClassList.courseClass;
    },
    sessions() {
      return this.$store.state.courseClassList.courseClassSessions;
    },
    trainee() {
      return this.$store.state.traineeAttendanceList.traineeAttendance;
    },
    instructors() {
      return this.$store.state.traineeAttendanceList.instructorAttendance;
    }
  },
  methods: {

    initValues() {
      this.search.date = "";
      this.search.CourseClass = {};
      this.search.ModuleID = "";
      this.modules = [];
      this.traineeParticipations = [];
    },
    formatJsDate(dateToFormat) {
      return dateToFormat.getFullYear() + "-" + (dateToFormat.getMonth() + 1) + "-" + dateToFormat.getDate();
    },
    PrintDailyFolloup() {
      debugger
      window.open('#/Report/DialyFollowUpTrainingEvaluation/' + this.search.CourseClass.ID + '/' + this.formatJsDate(this.search.date) + "/" + this.search.ModuleID);
    },
    submitData() {
      var data = {};
      data.date = this.formatJsDate(this.search.date);
      data.trainees = this.traineeParticipations;

      this.$store.dispatch("traineeParticipationList/SaveTraineeParticipation", data

      ).then(() => {
        this.initValues();
      });
    },
    loadTrainee() {
      debugger
      var data = {};
      data.moduleID = this.search.ModuleID;
      data.courseClassID = this.search.CourseClass.ID;
      this.$store.dispatch("traineeParticipationList/GetTraineeParticipationByCourseClassID", data).then((res) => {
        this.traineeParticipations = res.data;
        var x = this.traineeParticipations;
        var y =this.traineeParticipations[0].TraineeParticipations;
        var z =this.traineeParticipations[0].TraineeParticipations[0].ParticipationType.Name;
        var h =this.traineeParticipations[0].TraineeParticipations[0].ID;
        debugger
        var H1= this.traineeParticipations[0].FullName;
        var Hx= this.traineeParticipations[0].TraineeParticipations[0].ID;

        debugger
      });
      // this.$store.dispatch("traineeParticipationList/GetInstructorParticipationBySession",data);
    },
    getCourseClassByDay() {
      if (this.search.date != undefined) {

        if (JSON.parse(localStorage.getItem("userInfo")).userRole == 'instructor' || JSON.parse(localStorage.getItem("userInfo")).userRole == 'evaluator') {
          this.$store.dispatch("courseClassList/GetCourseClassByDateForInstructor", this.formatJsDate(this.search.date));
        }
        else {
          this.$store.dispatch("courseClassList/GetCourseClassByDate", this.formatJsDate(this.search.date));
        }

      }
    },
    getModulesByCourseClass() {
      debugger
      var data = {};

      data.courseClassID = this.search.CourseClass.ID;
      data.CourseID = this.search.CourseClass.CourseID;
      this.$store.dispatch("traineeParticipationList/GetModuleByCourseID", data).then((res) => {
        this.modules = res.data;
      });
    },
    formatJsDate(dateToFormat) {
      return dateToFormat.getFullYear() + "-" + (dateToFormat.getMonth() + 1) + "-" + dateToFormat.getDate();
    },
  },
  created() {
    if (!moduleCourseClass.isRegistered) {
      this.$store.registerModule("courseClassList", moduleCourseClass);
      moduleCourseClass.isRegistered = true;
    }

    if (!moduleTraineeAttendance.isRegistered) {
      this.$store.registerModule("traineeAttendanceList", moduleTraineeAttendance);
      moduleTraineeAttendance.isRegistered = true;
    }

    if (!moduleTraineeParticipation.isRegistered) {
      this.$store.registerModule("traineeParticipationList", moduleTraineeParticipation);
      moduleTraineeParticipation.isRegistered = true;
    }
    debugger;
    this.currentRule = JSON.parse(localStorage.getItem("userInfo")).userRole;

  }
}
</script>



<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style>
.vdp-datepicker__calendar {
  z-index: 429 !important;
}
</style>
